import { DirectoryOrgRepInfo } from '@platform/client/schemas';
import { UserCard } from './OrgRepCard';
import { getLinkedInLink } from './InfoCard';
import { formatLocation } from './util';

export const RepsList = ({ reps }: { reps: DirectoryOrgRepInfo[] }) => {
  return (
    <div className='grid grid-cols-1 sm:grid-cols-3 gap-8'>
      {reps.map((rep) => (
        <UserCard
          key={rep.name}
          avatarUrl={rep.avatarUrl}
          name={rep.name}
          title={rep.title}
          languages={rep.languages}
          location={formatLocation(rep.city, rep.country)}
          linkedInAccount={rep.linkedinName ? getLinkedInLink(rep.linkedinName) : undefined}
          isProjectLead={rep.isProjectLead ?? false}
        />
      ))}
    </div>
  );
};
